import { render } from "./tenantsSms.vue?vue&type=template&id=79ba6b95&scoped=true"
import script from "./tenantsSms.vue?vue&type=script&lang=js"
export * from "./tenantsSms.vue?vue&type=script&lang=js"

import "./tenantsSms.vue?vue&type=style&index=0&id=79ba6b95&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ba6b95"]])

export default __exports__